import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { FilesPage } from '../../Views'

export const filesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/files',
  component: FilesPage,
})
